import { EmptyState } from '@chopchop-se/ui';
import { TriangleAlert } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { errorMessage } from '../../../lib/notify';

/**
 * What a detail page renders when its query fails.
 *
 * Without this a 403 (`E_RESTAURANT_FORBIDDEN` on someone else's restaurant) or
 * a 404 leaves the page spinning forever, which reads as "the system hung"
 * rather than "you may not see this". The message comes from the api's
 * `{ code, params }` envelope, so it is already localized.
 */
export function LoadFailure({ error }: { error: unknown }): ReactNode {
  const { t } = useTranslation('shell');
  return (
    <EmptyState icon={<TriangleAlert />} title={t('table.loadFailed')} description={errorMessage(error)} />
  );
}
